import mentorFormModel from "./mentorFormModel";
const {
  formField: {
    //page1
    email,
    password,
    academicTitle,
    nameEng,
    middleNameEng,
    surnameEng,
    titleNameThai,
    nameThai,
    middleNameThai,
    surnameThai,
    //page2
    faculty,
    department,
    mobileNumber,
    dateOfBirth,
    //page3
    postdocFellowshipRecieve,
    typeAllPostdocs,
    postdocCurrently,
    postdocUnderSupervision,
    resignedPostdoc,
    phdScholarship,
    allPhDStudents,
    phdStudents,
    studentUnderSupervision,
    resignedStudent
  }
} = mentorFormModel;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [email.name]: "",
  [password.name]: "",
  [academicTitle.name]: "",
  [nameEng.name]: "",
  [middleNameEng.name]: "",
  [surnameEng.name]: "",
  [titleNameThai.name]: "",
  [nameThai.name]: "",
  [middleNameThai.name]: "",
  [surnameThai.name]: "",
  //page2
  [faculty.name]: "",
  [department.name]: "",
  [mobileNumber.name]: "",
  [dateOfBirth.name]: "",
  //page3
  [postdocFellowshipRecieve.name]: "",
  [typeAllPostdocs.name]: "",
  [postdocCurrently.name]: "",
  [postdocUnderSupervision.name]: "",
  [resignedPostdoc.name]: "",
  [phdScholarship.name]: "",
  [allPhDStudents.name]: "",
  [phdStudents.name]: "",
  [studentUnderSupervision.name]: "",
  [resignedStudent.name]: ""
};
